// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {format_sessions} from './utils';
import {i_task_result, i_zone_session_state} from './types';

/* eslint-disable */
export enum SESSION_ACTIONS {
    SET_ZONE_ID = 'set_zone_id',
    SET_BUSY = 'set_busy',
    SET_ERROR = 'set_error',
    SET_SESSIONS = 'set_sessions',
    ADD_SESSION = 'add_session',
    UPDATE_SESSION = 'update_session',
    ADD_SESSION_RESULT = 'add_session_result',
}
/* eslint-enable */

export type t_session_action =
    | {type: SESSION_ACTIONS.SET_ZONE_ID; payload: string}
    | {type: SESSION_ACTIONS.SET_BUSY; payload: boolean}
    | {type: SESSION_ACTIONS.SET_ERROR; payload: string | null}
    | {type: SESSION_ACTIONS.SET_SESSIONS; payload: {
        sessions: any[];
        results?: Record<string, i_task_result[]>;
        error?: string | null;
      }}
    | {type: SESSION_ACTIONS.ADD_SESSION; payload: any}
    | {type: SESSION_ACTIONS.UPDATE_SESSION; payload: any}
    | {type: SESSION_ACTIONS.ADD_SESSION_RESULT; payload: {
        task_id: string;
        result: any;
      }};

export const sessions_reducer = (
    state: i_zone_session_state,
    action: t_session_action): i_zone_session_state=>
    {
    switch (action.type)
    {
        case SESSION_ACTIONS.SET_ZONE_ID:
            return {...state, zone_id: action.payload};
        case SESSION_ACTIONS.SET_BUSY:
            return {...state, is_busy: action.payload};
        case SESSION_ACTIONS.SET_ERROR:
            return {...state, error: action.payload};
        case SESSION_ACTIONS.SET_SESSIONS:
            return {
                ...state,
                sessions: format_sessions(action.payload.sessions),
                results: action.payload.results || state.results,
                error: action.payload.error,
                is_busy: false
            };
        case SESSION_ACTIONS.ADD_SESSION:
            return {
                ...state,
                sessions: format_sessions([...state.sessions, action.payload]),
            };
        case SESSION_ACTIONS.UPDATE_SESSION: {
            const new_sessions = state.sessions.map(s=>{
                if (s._id != action.payload._id)
                    return s;
                return {...s, ...action.payload};
            });
            return {
                ...state,
                sessions: format_sessions(new_sessions),
            };
        }
        case SESSION_ACTIONS.ADD_SESSION_RESULT: {
            const {task_id, result} = action.payload;
            const cur_task_results = state.results?.[task_id] ?? [];
            return {
                ...state,
                results: {
                    ...state.results,
                    [task_id]: [...cur_task_results, result],
                },
            };
        }
        default:
            return state;
    }
};
